
import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData, updateData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import AsyncSelect from 'react-select/async';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "./Al-Hadi.png";

const PaymentAndReceiptEdit = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        fetchPaymentmethodTypes();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        fetchData('PaymentAndReceiptApi', `/PaymentData/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    const invoiceData = response.response_data.PaymentAndReceipt;
                    setFormData({
                        ...invoiceData,
                        UpdatedBy: userId,
                    });
                    console.log(response);

                    const updatedInvoicedetailsSorted = response.response_data.PaymentAndReceiptInvoiceDetails;
                    setInvoicedeatils(updatedInvoicedetailsSorted);

                    setSelectedCustomer({
                        value: response.response_data.PaymentAndReceipt.CustomerId,
                        label: response.response_data.PaymentAndReceipt.CustomerName
                    });

                    setSelectedConsignee({
                        value: response.response_data.PaymentAndReceipt.ConsigneeId,
                        label: response.response_data.PaymentAndReceipt.ConsigneeName
                    });

                    // console.log(updatedInvoicedetailsSorted);
                }
            })
            .catch((error) => {
                console.error('Error fetching PaymentAndReceipt Details:', error);
            });
    }, [id]);

    const [recordCount, setRecordCount] = useState(0);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const [formData, setFormData] = useState({
        CompanyId: companyId,
        ModifiedBy: userId,
        isSubmit: false,
        IsType: true,
    });

    const [showBankField, setShowBankField] = useState(true);

    // Handle customer selection
    const handleCustomerSelect = (selectedOption) => {
        setSelectedCustomer(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            CustomerId: selectedOption ? selectedOption.value : '',
            ModifiedBy: userId,
        }));
    };

    useEffect(() => {
        fetchCustomerData();
        fetchConsigneeData();
    }, []);

    //FOR GET Customer  Details FROM API
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const fetchCustomerData = () => {
        fetchData('PaymentAndReceiptApi', `/Customer/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                // Transform the data into the format that react-select expects (label and value)                
                const options = data.map((customer) => ({
                    label: customer.Name,
                    value: customer.Id,
                }));
                setCustomerOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching Customer data:', error);
            });
    };

    const [ConsigneeOptions, setConsigneeOptions] = useState([]);
    const [selectedConsignee, setSelectedConsignee] = useState(null);

    //FOR GET Consignee  Details FROM API
    const fetchConsigneeData = () => {
        fetchData('PaymentAndReceiptApi', `/Consignee/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                // Transform the data into the format that react-select expects (label and value)                
                const options = data.map((Consignee) => ({
                    label: Consignee.Name,
                    value: Consignee.Id,
                }));
                setConsigneeOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching Consignee data:', error);
            });
    };

    const distributeAmountAcrossBills = (amount, invoiceDetails) => {
        let remaining = amount;
        return invoiceDetails.map(inv => {
            const billAmt = Number(inv.Amount || 0);
            const alreadyPaid = Number(inv.PaidAmount || 0);
            const pending = billAmt - alreadyPaid;
            let payNow = 0;
            let balance = pending;
            if (remaining > 0) {
                if (remaining >= pending) {
                    payNow = pending;   // full settle this bill
                    balance = 0;
                    remaining -= pending;
                } else {
                    payNow = remaining; // partial settle this bill
                    balance = pending - remaining;
                    remaining = 0;
                }
            }
            return {
                ...inv,
                PaidNow: payNow,             // new field
                NewBalance: balance          // new field
            };
        });
    };

    const handleConsigneeChange = (selectedOption) => {
        setSelectedConsignee(selectedOption);

        setFormData((prevData) => ({
            ...prevData,
            ConsigneeId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));

        //console.log("Selected Consignee:", selectedOption);

        if (selectedOption && selectedCustomer) {
            fetchData(
                'PaymentAndReceiptApi',
                `/CustomerReceiptBill/${companyId}/${branchId}/${selectedCustomer.value}/${selectedOption.value}`,
                token
            )
                .then((response) => {
                    if (response.responseCode === '1111') {
                        const updatedInvoicedetailsSorted = response.response_data;

                        const totalPendingBalance = updatedInvoicedetailsSorted.reduce((total, invdetail) => {
                            return total + Number(invdetail.BalanceAmount || 0);
                        }, 0);

                        // Distribute initially with full pending
                        const distributed = distributeAmountAcrossBills(totalPendingBalance, updatedInvoicedetailsSorted);

                        setFormData((prevData) => ({
                            ...prevData,
                            TotalBalAmt: totalPendingBalance,
                            Amount: totalPendingBalance,  // auto-fill
                        }));

                        setInvoicedeatils(distributed);
                    }
                })
                .catch((error) => {
                    console.error('Error fetching invoice details:', error);
                });
        }
    };

    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: name === "IsType"
                ? value === "1"
                : name === "PaymentType"
                    ? Number(value) // Ensure PaymentType is stored as a number
                    : type === "checkbox"
                        ? checked
                        : value,
        }));

        if (name === "Amount" && invoicedeatils.length > 0) {
            const distributed = distributeAmountAcrossBills(Number(value), invoicedeatils);
            setInvoicedeatils(distributed);
        }
        let ispaymentType = true;
    };

    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    const [selectedPaymentType, setSelectedPaymentType] = useState("1");

    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = invoicedeatils.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    //customer Payment Method 
    const [paymentmethodOptions, setPaymentmethodOptions] = useState([]);
    const [selectedPaymentmethodType, setSelectedPaymentmethodType] = useState("");

    const fetchPaymentmethodTypes = async () => {
        try {
            const response = await fetchData('PaymentAndReceiptApi', `/PaymentModes/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setPaymentmethodOptions(options);
                setShowBankField(true);
            }
        } catch (error) {
            console.error('Error fetching PaymentModes:', error);
        }
    };

    const handlePaymentTypeChange = (selectedOption) => {
        setSelectedPaymentmethodType(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            PaymentType: selectedOption.value,
        }));
        if (["Cheque", "RTGS", "NEFT", "UPI"].includes(selectedOption.label)) {
            setShowBankField(false);
        } else {
            setShowBankField(true);
        }
    };

    useEffect(() => {
        fetchPaymentmethodTypes();
    }, []);

    //FromBank
    const [bankOptions, setBankOptions] = useState([]);
    const [selectedBank, setSelectedBank] = useState("");

    const fetchBanks = async () => {
        try {
            const response = await fetchData('PaymentAndReceiptApi', `/Banks/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setBankOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Bank:', error);
        }
    };

    const handleBankChange = (selectedOption) => {
        setSelectedBank(selectedOption);
    };

    useEffect(() => {
        fetchBanks();
    }, []);

    //ToBank
    const [tobankOptions, setToBankOptions] = useState([]);
    const [selectedToBank, setSelectedToBank] = useState("");

    const fetchToBanks = async () => {
        try {
            const response = await fetchData('PaymentAndReceiptApi', `/Banks/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setToBankOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Bank:', error);
        }
    };

    const handleToBankChange = (selectedOption) => {
        setSelectedToBank(selectedOption);
    };

    useEffect(() => {
        fetchToBanks();
    }, []);

    // ===================== SUBMIT DATA =================
    const submitData = async (e) => {
        setIsLoading(true);

        if (!formData.CustomerId || formData.CustomerId === 0) {
            setErrorMessage('Customer is required!');
            setIsLoading(false);
            return;
        }

        if (!formData.ConsigneeId || formData.ConsigneeId === 0) {
            setErrorMessage('Consignee is required!');
            setIsLoading(false);
            return;
        }

        if (!formData.Amount || formData.Amount === 0) {
            setErrorMessage('Amount must be Greater than 0!');
            setIsLoading(false);
            return;
        }

        // Validation for non-cash payment types
        if (selectedPaymentmethodType && selectedPaymentmethodType.label !== 'Cash') {
            if (!formData.ChequeNumber) {
                setErrorMessage('Reference No is required for non-cash payments!');
                setIsLoading(false);
                return;
            }
            if (!formData.ChequeDate) {
                setErrorMessage('Reference Date is required for non-cash payments!');
                setIsLoading(false);
                return;
            }
            if (!formData.chequeDetails) {
                setErrorMessage('Reference Details are required for non-cash payments!');
                setIsLoading(false);
                return;
            }
            if (!selectedBank) {
                setErrorMessage('Bank selection is required for non-cash payments!');
                setIsLoading(false);
                return;
            }
        }

        const updatedFormData = {
            ...formData,
            CreatedBy: userId,
            FromBankId: selectedBank ? selectedBank.value : null,
            ToBankId: selectedToBank ? selectedToBank.value : null,
        };

        const createData = {
            PaymentAndReceipt: updatedFormData,
            PaymentAndReceiptInvoiceDetails: invoicedeatils,
        };
        try {
            const response = await updateData('PaymentAndReceiptApi', `${id}`, createData, token);//postData('PaymentAndReceiptApi', createData, token);

            const SaleId = response.kotId;
            generateInvoice(SaleId); // Handle print with SaleId

            setSuccessMessage('Receipt Created successfully!');
            setErrorMessage('');

            history.push('/PaymentAndReceiptIndex');
            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);

        } catch (error) {
            console.error('Receipt Create error:', error);
            if (error.response) {
                console.error('Response data:', error.response.data);
                console.error('Response status:', error.response.status);
                console.error('Response headers:', error.response.headers);
            } else if (error.request) {
                console.error('Request was made but no response received:', error.request);
            } else {
                console.error('Error in setting up the request:', error.message);
            }
            setErrorMessage('Failed to create Payment. Please try again.');
            setIsLoading(false);
        }
    };

    const generateInvoice = async (ReceiptId) => {
        try {
            const doc = new jsPDF("p", "mm", "a4");
            const pageWidth = doc.internal.pageSize.getWidth();

            // ===== FETCH DATA =====
            const response = await fetchData('PaymentAndReceiptApi', `/ReceiptPrint/${ReceiptId}`, token);
            const header = response.response_data;
            if (!header) throw new Error("Invalid receipt data.");

            // ===== HARD CODED COMPANY INFO =====
            doc.setFont("times", "normal");
            doc.setFontSize(11);
            doc.text("C.R.No: 133768/8", 15, 20);
            doc.text("GSM: 99350447 / 99375290 /", 15, 26);
            doc.text("98524923 / 92497852", 15, 32);

            doc.text("Fax : 24712328", pageWidth - 60, 20);
            doc.text("P.O.Box : 1485,", pageWidth - 60, 26);
            doc.text("Jibroo Postal Code : 114,", pageWidth - 60, 32);
            doc.text("Sultanate of Oman", pageWidth - 60, 38);

            // ===== LOGO =====
            const logoWidth = 75;
            const logoHeight = 25;
            const logoX = (pageWidth - logoWidth) / 2;
            const logoY = 35;
            doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

            // ===== AMOUNT SPLIT (R.O. / BZ.) =====
            const amount = header.Amount || 0;
            const rials = Math.floor(amount);
            const baiza = Math.round((amount - rials) * 100);

            const sectionY = 60;
            const leftX = 20;
            const rightX = pageWidth - 50;

            // ---- LEFT SIDE (R.O. / BZ.) ----
            autoTable(doc, {
                startY: sectionY,
                margin: { left: leftX },
                body: [["R.O.", "BZ."]],
                theme: "plain",
                styles: { halign: "center", fontStyle: "bold", fontSize: 12 },
                columnStyles: {
                    0: { cellWidth: 30 }, // R.O. column width
                    1: { cellWidth: 30 }  // BZ. column width
                }
            });

            autoTable(doc, {
                startY: doc.lastAutoTable.finalY + 2,
                margin: { left: leftX },
                body: [[rials.toString(), baiza.toString().padStart(3, "0")]],
                theme: "grid",
                styles: {
                    halign: "center",
                    fontSize: 14,
                    fontStyle: "bold",
                    lineWidth: 0.2,
                    lineColor: [0, 0, 0],
                    textColor: [0, 0, 0] // ✅ set text color to black
                },
                columnStyles: {
                    0: { cellWidth: 30 }, // R.O.
                    1: { cellWidth: 30 }  // BZ.
                }
            });


            // ---- RIGHT SIDE (Voucher Details) ----
            doc.setFont("times", "normal");
            doc.setFontSize(12);
            doc.text(`No.: ${header.ReferenceNo || ""}`, rightX, sectionY + 8);
            doc.text(`Date: ${header.ReferenceDate ? new Date(header.ReferenceDate).toLocaleDateString('en-GB') : ""}`, rightX, sectionY + 16);

            let y = doc.lastAutoTable.finalY + 12;

            // ===== RECEIVED FROM =====
            doc.setFont("times", "normal");
            doc.text("Received with thanks from Mr/M/s", 15, y);
            doc.setFont("times", "bold");
            doc.text((header.PartyName || "").toUpperCase(), 85, y);
            doc.setLineDash([1, 1], 0);
            doc.line(80, y + 1, pageWidth - 15, y + 1);

            // ===== ON BEHALF OF =====
            y += 8;
            doc.setFont("times", "normal");
            doc.text("On Behalf Of", 15, y);
            doc.setFont("times", "bold");
            doc.text((header.CompanyName || "").toUpperCase(), 55, y);
            doc.line(50, y + 1, pageWidth - 15, y + 1);

            // ===== AMOUNT IN WORDS =====
            y += 8;
            const amountInWords = ConvertAmountToRialBaisa(amount);
            doc.setFont("times", "normal");
            doc.text("The Sum of Rials Omani", 15, y);

            doc.setFont("times", "bold");
            const textX = 65;
            doc.text(amountInWords, textX, y);
            doc.line(textX, y + 1, pageWidth - 15, y + 1);

            // ===== CASH / CHEQUE =====
            y += 12;
            doc.setFont("times", "normal");
            doc.text("By Cash / Cheque No", 15, y);
            doc.line(55, y + 1, 80, y + 1);
            doc.setFont("times", "bold");
            doc.text(header.PaymentType || "Cash", 60, y);

            doc.setFont("times", "normal");
            doc.text("Bank", 100, y);
            doc.line(115, y + 1, 140, y + 1);
            doc.setFont("times", "bold");
            doc.text(header.BankName || "", 145, y);

            doc.text("Date", 160, y);
            doc.setFont("times", "bold");
            doc.text(header.ReferenceDate ? new Date(header.ReferenceDate).toLocaleDateString('en-GB') : "", 175, y);

            // ===== BEING =====
            y += 10;
            doc.setFont("times", "normal");
            doc.text("Being", 15, y);
            doc.line(30, y + 1, pageWidth - 15, y + 1);

            // ===== FOOTER =====
            y += 20;
            doc.setFont("times", "normal");
            doc.text("Accountant", 15, y);
            doc.line(40, y + 1, 90, y + 1);

            doc.text("Receiver's Signature", 140, y);
            doc.line(180, y + 1, pageWidth - 15, y + 1);

            // ===== OPEN & PRINT =====
            const blob = doc.output('blob');
            const blobUrl = URL.createObjectURL(blob);
            const printWindow = window.open(blobUrl, '_blank');
            if (printWindow) {
                printWindow.onload = () => {
                    printWindow.focus();
                    printWindow.print();
                };
            }
        } catch (error) {
            console.error("Error generating receipt:", error);
        }
    };

    // ===================== HELPERS =====================
    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (num) => {
            if (num === 0) return '';
            if (num < 10) return units[num];
            if (num === 10) return tens[1];
            if (num < 20) return teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + units[num % 10] : '');
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred' + (num % 100 !== 0 ? ' ' + convert(num % 100) : '');
            if (num < 100000) return convert(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 !== 0 ? ' ' + convert(num % 1000) : '');
            if (num < 10000000) return convert(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 !== 0 ? ' ' + convert(num % 100000) : '');
            return 'Number is too large';
        };

        if (num === 0) return 'Zero';
        return convert(num).trim();
    };

    const ConvertAmountToRialBaisa = (amount) => {
        const formattedAmount = parseFloat(amount).toFixed(3); // keep 3 decimals
        const [rials, baisa] = formattedAmount.split('.');

        let words = `${NumberToWords(parseInt(rials))} Rial`;
        if (parseInt(rials) !== 1) words += "s"; // plural

        if (baisa && parseInt(baisa) > 0) {
            words += ` And ${NumberToWords(parseInt(baisa))} Baisa`;
        }
        return words + " Only";
    };

    const parseAndFix = (val) => parseFloat(val) || 0;

    useEffect(() => {
        let amt = parseAndFix(formData.Amount);
        const TaxRate = parseAndFix(formData.TaxRate);
        let taxAmount = 0;
        taxAmount = ((amt * TaxRate) / 100).toFixed(2);
        let netAmount = parseAndFix(amt) + parseAndFix(taxAmount);
        let roundOff = Math.round(netAmount) - netAmount;
        let grandTotal = netAmount + roundOff;

        setFormData((prev) => ({
            ...prev,
            Amount: amt,
            TaxAmount: parseFloat(taxAmount).toFixed(2),
            RoundOff: parseFloat(roundOff).toFixed(2),
            TotalAmount: parseFloat(grandTotal).toFixed(2),
        }));
    }, [formData.Amount, formData.TaxRate]);

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '100%', marginTop: '-45px' }}>

            <div className="flex flex-wrap justify-between items-center mb-4">
                <h6
                    className="uppercase tracking-wide text-black font-serif flex-grow"
                    style={{
                        fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                        color: 'black',
                        marginTop: '10px',
                    }}
                >
                    Receipt Edit
                </h6>

                <div className="flex mt-8 w-full sm:w-auto">


                    <Button
                        variant="contained"
                        color="primary"
                        onClick={submitData}
                        disabled={isLoading}
                        style={{ height: "25px", borderRadius: "10px" }}
                    >
                        {isLoading ? <CircularProgress size={22} color="inherit" /> : "Update"}
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        component={Link}
                        to={{
                            pathname: "/PaymentAndReceiptIndex",
                            state: { from: "/PaymentAndReceiptEdit" },
                        }}
                        onClick={() => {
                            localStorage.setItem("shouldReload", "true");
                        }}
                        style={{ height: "25px", borderRadius: "10px", marginRight: "5px", marginLeft: '15px', }}
                    >
                        Back To List
                    </Button>
                </div>
            </div>

            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            <div className="w-full flex flex-wrap" style={{ backgroundColor: '#D3E0DC', padding: '7px', borderRadius: '10px', marginTop: '-15px' }}>

                <div className="w-full pr-4" style={{ marginTop: '-0.21%' }}>
                    <div className="w-full mb-2 flex">
                        <div className="w-3/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="supplierName">
                                Customer
                            </label>
                            <Select
                                value={selectedCustomer}
                                onChange={handleCustomerSelect}
                                options={customerOptions}
                                placeholder="Select Customer"
                                isSearchable
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: '30px',
                                        fontSize: '13px',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 1301,
                                        fontSize: '13px',
                                    }),
                                    indicatorsContainer: (base) => ({
                                        ...base,
                                        height: '30px',
                                    }),
                                }}
                            />
                        </div>

                        <div className="w-3/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="supplierName">
                                Consignee
                            </label>
                            <Select
                                value={selectedConsignee}
                                onChange={handleConsigneeChange}
                                options={ConsigneeOptions}
                                placeholder="Select Consignee"
                                isSearchable
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: '30px',
                                        fontSize: '13px',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 1301,
                                        fontSize: '13px',
                                    }),
                                    indicatorsContainer: (base) => ({
                                        ...base,
                                        height: '30px',
                                    }),
                                }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billDate">
                                Bill Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.BillDate)}
                                onChange={handleChange}
                                type="date"
                                name='BillDate'                                
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billNumber">
                                Bill No
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={`${formData.BillNumber || ''}`}
                                onChange={handleChange}
                                type="text"
                                placeholder="Bill Number"
                                name='BillNumber'
                                readOnly
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="supplierName">
                                Pay Mode
                            </label>

                            <Select
                                value={selectedPaymentmethodType || { value: 'cash', label: 'Cash' }}  // Default to "Cash" if not selected
                                onChange={handlePaymentTypeChange}
                                options={paymentmethodOptions}
                                placeholder="PaymentOption"
                                isSearchable
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: '30px',
                                        fontSize: '13px',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 1301,
                                        fontSize: '13px',
                                    }),
                                    indicatorsContainer: (base) => ({
                                        ...base,
                                        height: '30px',
                                    }),
                                }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billNumber">
                                Amount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={
                                    formData.Amount != null && formData.Amount !== ''
                                        ? Number(formData.Amount).toFixed(3)   // ✅ format to 3 decimals
                                        : ''
                                }
                                onChange={handleChange}
                                type="number"
                                placeholder="Amount"
                                name='Amount'
                                disabled={invoicedeatils.length > 0}
                                style={{ textAlign: 'right', fontWeight: 'bold', height: '35px' }}
                            />
                        </div>

                    </div>

                    <div className="w-full mb-2 flex">

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billNumber">
                                {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'From Cheque Bank' : 'From Bank'}
                                <span className="text-red-500">*</span>
                            </label>
                            <Select
                                value={selectedBank || { value: '', label: 'Select Bank' }}
                                onChange={handleBankChange}
                                options={bankOptions}
                                placeholder="Select Bank"
                                isSearchable
                                isDisabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: '30px',
                                        fontSize: '13px',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 1301,
                                        fontSize: '13px',
                                    }),
                                    indicatorsContainer: (base) => ({
                                        ...base,
                                        height: '30px',
                                    }),
                                }}
                            />
                        </div>
                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billNumber">
                                {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'To Cheque Bank' : 'To Bank'}
                                <span className="text-red-500">*</span>
                            </label>
                            <Select
                                value={selectedToBank || { value: '', label: 'Select Bank' }}
                                onChange={handleToBankChange}
                                options={tobankOptions}
                                placeholder="Select Bank"
                                isSearchable
                                isDisabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: '30px',
                                        fontSize: '13px',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 1301,
                                        fontSize: '13px',
                                    }),
                                    indicatorsContainer: (base) => ({
                                        ...base,
                                        height: '30px',
                                    }),
                                }}
                            />
                        </div>

                        <div className="w-1/6 mr-2">

                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billNumber">
                                {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque No' : 'Reference No'}
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.ChequeNumber}
                                type="text"
                                placeholder=""
                                name="ChequeNumber"
                                onChange={handleChange}
                                style={{ height: '35px' }}
                                disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                            />
                        </div>

                        <div className="w-1/8 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billNumber">
                                {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque Date' : 'Reference Date'}
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.ChequeDate)}
                                type="date"
                                placeholder=""
                                name="ChequeDate"
                                onChange={handleChange}
                                style={{ height: '35px' }}
                                disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billNumber">
                                {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque Details' : 'Reference Details'}
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.chequeDetails}
                                type="text"
                                placeholder=""
                                name="chequeDetails"
                                onChange={handleChange}
                                style={{ height: '35px' }}
                                disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billNumber">
                                Remarks
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Remarks"
                                name="Remarks"
                                value={formData.Remarks}
                                onChange={handleChange}
                                style={{ height: '35px', width: '100%' }}
                            />
                        </div>

                    </div>
                </div>
            </div>
            <div>
                {invoicedeatils.length > 0 && (
                    <div className="rounded-lg shadow-lg p-2" style={{ backgroundColor: '#D3E0DC', padding: '7px', borderRadius: '10px', marginTop: '5px' }}>
                        <div className="w-full mb-2 flex">
                            <div className="w-full mb-2 flex">
                                {invoicedeatils.length > 0 && (
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow sx={{ backgroundColor: '#343b42ff' }}>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '3px', textTransform: 'uppercase', color: 'white' }}>
                                                        Bill Details
                                                    </TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '3px', textTransform: 'uppercase', textAlign: 'right', color: 'white' }}>
                                                        Bill Amt
                                                    </TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '3px', textTransform: 'uppercase', textAlign: 'right', color: 'white' }}>
                                                        Paid Amt
                                                    </TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '3px', textTransform: 'uppercase', textAlign: 'right', color: 'white' }}>
                                                        Bal Amt
                                                    </TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white' }} />
                                                </TableRow>
                                            </TableHead>

                                            <TableBody sx={{ backgroundColor: 'rgba(182, 229, 225, 0.3)' }}>
                                                {invoicedeatils.map((invdetail) => (
                                                    <TableRow key={invdetail.Id}>
                                                        <TableCell style={{ borderBottom: '1px solid grey', padding: '4px' }}>
                                                            {invdetail.InvoiceDescription}
                                                        </TableCell>

                                                        {/* Bill Amount */}
                                                        <TableCell style={{ borderBottom: '1px solid grey', textAlign: 'right', padding: '4px' }}>
                                                            {invdetail.Amount != null ? Number(invdetail.Amount).toFixed(3) : "-"}
                                                        </TableCell>

                                                        {/* Paid Amount */}
                                                        <TableCell style={{ borderBottom: '1px solid grey', textAlign: 'right', color: 'black', padding: '4px' }}>
                                                            {invdetail.PaidNow != null
                                                                ? Number(invdetail.PaidNow).toFixed(3)
                                                                : invdetail.PaidAmount != null
                                                                    ? Number(invdetail.PaidAmount).toFixed(3)
                                                                    : "-"}
                                                        </TableCell>

                                                        {/* Balance Amount */}
                                                        <TableCell style={{ borderBottom: '1px solid grey', textAlign: 'right', color: 'red', padding: '4px' }}>
                                                            {invdetail.NewBalance != null
                                                                ? Number(invdetail.NewBalance).toFixed(3)
                                                                : invdetail.BalanceAmount != null
                                                                    ? Number(invdetail.BalanceAmount).toFixed(3)
                                                                    : "-"}
                                                        </TableCell>

                                                        <TableCell style={{ borderBottom: '1px solid grey' }} />
                                                    </TableRow>
                                                ))}

                                                {/* === Totals Calculation === */}
                                                {(() => {
                                                    const totalBill = invoicedeatils.reduce((sum, inv) => sum + Number(inv.Amount || 0), 0);
                                                    const totalPaid = invoicedeatils.reduce(
                                                        (sum, inv) => sum + Number(inv.PaidNow ?? (inv.PaidAmount || 0)),
                                                        0
                                                    );
                                                    const totalBalance = invoicedeatils.reduce(
                                                        (sum, inv) => sum + Number(inv.NewBalance ?? (inv.BalanceAmount || 0)),
                                                        0
                                                    );

                                                    return (
                                                        <>
                                                            {/* === Footer Row (Total) === */}
                                                            <TableRow sx={{ backgroundColor: '#eee9caff' }}>
                                                                <TableCell colSpan={1} sx={{ fontWeight: 'normal', padding: '4px', color: 'black', textTransform: 'uppercase' }}>
                                                                    Total
                                                                </TableCell>

                                                                {/* Total Bill Amount */}
                                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '4px' }}>
                                                                    {invoicedeatils.reduce((sum, inv) => sum + Number(inv.Amount || 0), 0).toFixed(3)}
                                                                </TableCell>

                                                                {/* Total Paid */}
                                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', color: 'darkmagenta', padding: '4px' }}>
                                                                    {invoicedeatils.reduce(
                                                                        (sum, inv) => sum + Number(inv.PaidNow ?? (inv.PaidAmount || 0)),
                                                                        0
                                                                    ).toFixed(3)}
                                                                </TableCell>

                                                                {/* Total Balance */}
                                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', color: 'brown', padding: '4px' }}>
                                                                    {invoicedeatils.reduce(
                                                                        (sum, inv) => sum + Number(inv.NewBalance ?? (inv.BalanceAmount || 0)),
                                                                        0
                                                                    ).toFixed(3)}
                                                                </TableCell>
                                                                <TableCell />
                                                            </TableRow>

                                                            {/* === Advance Row (Only if Amount > Total Bill Amount) === */}
                                                            {Number(formData.Amount) >
                                                                invoicedeatils.reduce((sum, inv) => sum + Number(inv.Amount || 0), 0) && (
                                                                    <TableRow sx={{ backgroundColor: '#e6f3c8ff' }}>
                                                                        <TableCell colSpan={2} sx={{ fontWeight: 'normal', padding: '4px', color: 'black', textTransform: 'uppercase' }}>
                                                                            Advance
                                                                        </TableCell>
                                                                        <TableCell
                                                                            colSpan={2}
                                                                            sx={{ textAlign: 'right', fontWeight: 'bold', color: 'darkblue', padding: '4px' }}
                                                                        >
                                                                            {(
                                                                                Number(formData.Amount) -
                                                                                invoicedeatils.reduce((sum, inv) => sum + Number(inv.Amount || 0), 0)
                                                                            ).toFixed(3)}
                                                                        </TableCell>
                                                                        <TableCell />
                                                                    </TableRow>
                                                                )}
                                                        </>
                                                    );
                                                })()}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}

                            </div>
                        </div>
                    </div>
                )}

            </div>

        </div >
    );
}

export default PaymentAndReceiptEdit;
